<template>
  <div id="digital-flop">
    <div
      v-for="item in digitalFlopData"
      :key="item.title"
      class="digital-flop-item"
    >
      <div class="digital-flop-title">{{ item.title }}</div>
      <div class="digital-flop">
        <dv-digital-flop
          :config="item.number"
          style="width:100px;height:50px;"
        />
        <div class="unit">{{ item.unit }}</div>
      </div>
    </div>

    <dv-decoration-10 />
  </div>
</template>

<script>
import dataStatisticsApi from '@/api/DataStatistics'

export default {
  name: 'DigitalFlop',
  data() {
    return {
      digitalFlopData: [],
      deviceActivated: 0,
      sellDevice: 0,
      deviceNumber: 0,
      userNumber: 0,
      dealerNumber: 0,
      employeeNumber: 0,
      suggestionNumber: 0,
      deviceRunNumber: 0,
      replaceReturnNumber: 0
    }
  },
  mounted() {
    this.createData()

    setInterval(this.getServerData, 30000)

    this.getServerData()
  },
  methods: {
    getServerData() {
      dataStatisticsApi.topBaseInfo()
        .then(response => {
          this.deviceActivated = response.data.deviceActivated
          this.deviceNumber = response.data.deviceNumber
          this.sellDevice = response.data.sellDevice
          this.userNumber = response.data.userNumber
          this.dealerNumber = response.data.dealerNumber
          this.employeeNumber = response.data.employeeNumber
          this.suggestionNumber = response.data.suggestionNumber
          this.deviceRunNumber = response.data.deviceRunNumber
          this.replaceReturnNumber = response.data.replaceReturnNumber
          this.createData()
        })
    },

    createData() {
      this.digitalFlopData = [
        {
          title: '所有设备',
          number: {
            number: [this.deviceNumber],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#f46827',
              fontWeight: 'bold'
            }
          },
          unit: '个'
        },
        {
          title: '已出货设备',
          number: {
            number: [this.sellDevice],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#40faee',
              fontWeight: 'bold'
            }
          },
          unit: '个'
        },
        {
          title: '激活设备',
          number: {
            number: [this.deviceActivated],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#4d99fc',
              fontWeight: 'bold'
            }
          },
          unit: '个'
        },
        {
          title: '用户数量',
          number: {
            number: [this.userNumber],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#4d99fc',
              fontWeight: 'bold'
            }
          },
          unit: '人'
        },
        {
          title: '经销商数量',
          number: {
            number: [this.dealerNumber],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#f46827',
              fontWeight: 'bold'
            }
          },
          unit: '人'
        },
        {
          title: '员工数量',
          number: {
            number: [this.employeeNumber],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#40faee',
              fontWeight: 'bold'
            }
          },
          unit: '人'
        },
        {
          title: '意见总数',
          number: {
            number: [this.suggestionNumber],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#4d99fc',
              fontWeight: 'bold'
            }
          },
          unit: '条'
        },
        {
          title: '运行数据',
          number: {
            number: [this.deviceRunNumber],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#f46827',
              fontWeight: 'bold'
            }
          },
          unit: '条'
        },
        {
          title: '退货换货',
          number: {
            number: [this.replaceReturnNumber],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#40faee',
              fontWeight: 'bold'
            }
          },
          unit: '次'
        }
      ]
    }
  }
}
</script>

<style lang="less">
#digital-flop {
  height: 150px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: rgba(6, 30, 93, 0.5);

  .dv-decoration-10 {
    position: absolute;
    width: 95%;
    left: 2.5%;
    height: 5px;
    bottom: 0px;
  }

  .digital-flop-item {
    width: 11%;
    height: 80%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-left: 3px solid rgb(6, 30, 93);
    border-right: 3px solid rgb(6, 30, 93);
  }

  .digital-flop-title {
    font-size: 20px;
    margin-bottom: 20px;
  }

  .digital-flop {
    display: flex;
  }

  .unit {
    margin-left: 10px;
    display: flex;
    align-items: flex-end;
    box-sizing: border-box;
    padding-bottom: 13px;
  }
}
</style>
